<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header" :class="{ 'page-header--scrolled': headerScrolled }">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button text="" default-href="/today"></ion-back-button>
        </ion-buttons>
        <ion-title>Push-рассылка</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background events-content" :fullscreen="true" @ionScroll="onContentScroll">
      <form class="ion-padding push-broadcast-form" @submit.prevent="sendBroadcast">
        <ion-card class="admin-card push-broadcast-card">
          <ion-card-header>
            <ion-card-title>Новое уведомление</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <p class="push-broadcast-hint">
              Сообщение получат все пользователи приложения с включёнными push-уведомлениями на устройстве.
            </p>

            <ion-item class="push-field" lines="full">
              <ion-label position="stacked">Заголовок</ion-label>
              <ion-input
                v-model="title"
                maxlength="120"
                placeholder="Например: Важное уведомление"
              ></ion-input>
            </ion-item>
            <p class="push-char-count">{{ title.length }} / 120</p>

            <ion-item class="push-field" lines="full">
              <ion-label position="stacked">Сообщение</ion-label>
              <ion-textarea
                v-model="body"
                auto-grow
                maxlength="1000"
                :rows="5"
                placeholder="Текст push-уведомления"
              ></ion-textarea>
            </ion-item>
            <p class="push-char-count">{{ body.length }} / 1000</p>

            <ion-button
              expand="block"
              type="submit"
              class="admin-primary-btn push-send-btn"
              :disabled="sending || !canSend"
            >
              {{ sending ? 'Отправляем…' : 'Отправить push' }}
            </ion-button>
          </ion-card-content>
        </ion-card>
      </form>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonLabel,
  IonPage,
  IonTextarea,
  IonTitle,
  IonToolbar,
  toastController,
} from '@ionic/vue';
import { defineComponent } from 'vue';
import AdminService from '@/services/admin.service';

export default defineComponent({
  name: 'AdminPushBroadcast',
  components: {
    IonBackButton,
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonContent,
    IonHeader,
    IonInput,
    IonItem,
    IonLabel,
    IonPage,
    IonTextarea,
    IonTitle,
    IonToolbar,
  },
  data() {
    return {
      title: '',
      body: '',
      sending: false,
      headerScrolled: false,
      adminService: new AdminService(),
    };
  },
  computed: {
    canSend(): boolean {
      return this.title.trim().length > 0 && this.body.trim().length > 0;
    },
  },
  methods: {
    onContentScroll(ev: CustomEvent) {
      const t = (ev.detail as { scrollTop?: number }).scrollTop || 0;
      this.headerScrolled = t > 8;
    },

    async sendBroadcast() {
      if (!this.canSend || this.sending) return;
      this.sending = true;
      try {
        await this.adminService.sendAdminPushBroadcast({
          title: this.title.trim(),
          body: this.body.trim(),
        });
        this.title = '';
        this.body = '';
        await this.showToast('Рассылка отправлена');
      } catch {
        await this.showToast('Не удалось отправить рассылку');
      } finally {
        this.sending = false;
      }
    },

    async showToast(message: string) {
      const toast = await toastController.create({
        message,
        duration: 3000,
        color: 'dark',
        position: 'top',
        cssClass: 'custom-toast',
      });
      await toast.present();
    },
  },
});
</script>

<style scoped>
.push-broadcast-form {
  max-width: 720px;
  margin: 0 auto;
}

.push-broadcast-card {
  margin: 0;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.push-broadcast-card ion-card-title {
  font-size: 1.15rem;
  font-weight: 600;
}

.push-broadcast-hint {
  margin: 0 0 16px;
  font-size: 0.9rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.65);
}

.push-field {
  --background: rgba(255, 255, 255, 0.06);
  --color: #fff;
  --border-color: rgba(255, 255, 255, 0.1);
  --padding-start: 14px;
  --padding-end: 14px;
  --inner-padding-end: 0;
  margin-bottom: 4px;
  border-radius: 12px;
}

.push-field::part(native) {
  border-radius: 12px;
}

.push-field ion-label {
  color: rgba(255, 255, 255, 0.85) !important;
  font-weight: 500;
}

.push-char-count {
  margin: 2px 4px 14px;
  text-align: right;
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.45);
}

.push-send-btn {
  margin-top: 8px;
}

.admin-primary-btn,
.admin-primary-btn.ion-activated,
.admin-primary-btn.ion-focused {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  --background-hover: var(--ion-color-orange-tint);
  --background-focused: var(--ion-color-orange-tint);
  --color: #fff;
  font-weight: 600;
  --border-radius: 14px;
}
</style>
